import { ComponentType, Fragment, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';

import { useAuth } from '@sbv-clients/shared-feature-auth';

import { DepartmentFormSelectField } from './department-field';
import { FacilityFormSelectField } from './facility-field';

export const FacilityAndDepartmentField = (props: {
  disabledFacility?: boolean;
  disabledDepartment?: boolean;
  FieldWrapper?: ComponentType<{ children: ReactNode }>;
  payPeriodKey?: string;
  employeeIdKey?: string;
}) => {
  const { isMultiFacility } = useAuth();
  const FieldWrapper = props.FieldWrapper ?? Fragment;
  const { watch } = useFormContext();
  const facilityId = watch('facilityId');
  const { setValue } = useFormContext();
  return (
    <>
      {isMultiFacility && (
        <FieldWrapper>
          <FacilityFormSelectField
            name="facilityId"
            fullWidth
            {...props}
            disabled={props.disabledFacility}
            onChange={() => {
              setValue('departmentId', null);
              if (props.payPeriodKey) {
                setValue(props.payPeriodKey, null);
              }
              if (props.employeeIdKey) {
                setValue(props.employeeIdKey, -1);
              }
            }}
          />
        </FieldWrapper>
      )}
      <FieldWrapper>
        <DepartmentFormSelectField
          size="small"
          name="departmentId"
          fullWidth
          {...props}
          disabled={props.disabledDepartment}
          facilityId={isMultiFacility ? facilityId : undefined}
        />
      </FieldWrapper>
    </>
  );
};
